/*
 Created by CHT 2019/12/4 10:11
*/

/**
 *
 * @type {number}
 */
export const CHART_STATUS_TYPE__EDIT = 0   // 处于编辑状态
export const CHART_STATUS_TYPE__VIEW = 1   // 处于展示状态
export const CHART_STATUS_TYPE__STYLE = 2   // 处于展示状态

/**
 * 图表分类 chartCategory
 * @type {string}
 */

export const CHART_CATEGORY__CHART = 'CHART_COMPONENT'          // 图表控件
export const CHART_CATEGORY__TEXT = 'TEXT_COMPONENT'            // 文本控件
export const CHART_CATEGORY__FILTER = 'FILTER_COMPONENT'        // 筛选控件
export const CHART_CATEGORY__DATA_GRID = 'DATAGRID_COMPONENT'   // 数据表格控件
export const CHART_CATEGORY__MEDIA = 'MEDIA_COMPONENT'          // 富媒体控件

export const CHART_CATEGORY__SHORTCUT = 'SHORTCUT_COMPONENT'  // 快捷方式图表
export const CHART_CATEGORY__TODO = 'TODO_COMPONENT'         // 待我处理图表
export const CHART_CATEGORY__FLOW = 'FLOW_COMPONENT'         // 我的流程组件图表
export const CHART_CATEGORY__CONTAINER = 'CONTAINER_COMPONENT'         // 我的流程组件图表

/**
 * 图表类型 chartType
 * @type {string}
 */
export const CHART_TYPE__DEFAULT = ''                      // 默认值
export const CHART_TYPE__STATISTICS = 'STATISTICS_CHART'   // 统计表 （图表控件）
export const CHART_TYPE__DETAILED = 'DESCRIPTION_CHART'    // 明细表 （图表控件）
export const CHART_TYPE__DATA = 'DATA_CHART'               // 数据表格（数据表格控件）
export const CHART_TYPE__CALENDAR = 'CALENDAR_CHART'       // 日历 （图表控件）
export const CHART_TYPE__TEXT = 'TEXT_CHART'               // 文本 （文本控件）
export const CHART_TYPE__FILTER_BTN = 'FILTER_BUTTON'      // 筛选按钮 （筛选控件）
export const CHART_TYPE__FILTER_CONTROL = 'FILTER_CONTROL' // 筛选器 （筛选控件）
export const CHART_TYPE__MEDIA_CHART = 'MEDIA_CHART'       // 富媒体图表 （富媒体控件）

export const CHART_TYPE__SHORTCUT_CHART = 'SHORTCUT_CHART'  // 快捷方式图表
export const CHART_TYPE__TODO_CHART = 'TODO_CHART'         // 待我处理图表
export const CHART_TYPE__FLOW_CHART = 'FLOW_CHART'         // 我的流程组件图表
export const CHART_TYPE__CONTAINER_CHART = 'FRONTEND_CONTAINER_CHART' // 容器图表

/**
 * 图表展示类型 showType
 * @type {string}
 */
export const SHOW_TYPE__DEFAULT = ''                                  // 默认值
export const SHOW_TYPE__INDICATOR = 'INDICATOR_GRAPHICS'              // 指标图
export const SHOW_TYPE__MEASURE = 'MEASURE_GRAPHICS'                  // 计量图
export const SHOW_TYPE__PIVOT_TABLE = 'TABLE_GRAPHICS'                    // 透视表
export const SHOW_TYPE__CLUSTER_BAR = 'CLUSTER_BAR_GRAPHICS'          // 簇状柱形图
export const SHOW_TYPE__STACKED_BAR = 'STACKED_BAR_GRAPHICS'          // 堆叠柱状图
export const SHOW_TYPE__PERCENT_BAR = 'RATE_STACKED_BAR_GRAPHICS'     // 百分比堆叠柱状图
export const SHOW_TYPE__STRIP = 'STRIP_GRAPHICS'                      // 条形图
export const SHOW_TYPE__STACKED_STRIP = 'STACKED_STRIP_GRAPHICS'      // 堆叠条形图
export const SHOW_TYPE__PERCENT_STRIP = 'RATE_STACKED_STRIP_GRAPHICS' // 百分比堆叠条形图
export const SHOW_TYPE__RADAR = 'RADAR_GRAPHICS'                      // 雷达图
export const SHOW_TYPE__LINE = 'LINE_GRAPHICS'                        // 折线图
export const SHOW_TYPE__AREA = 'AREA_GRAPHICS'                        // 面积图
export const SHOW_TYPE__PIE = 'PIE_GRAPHICS'                          // 饼图
export const SHOW_TYPE__FUNNEL = 'FUNNEL_GRAPHICS'                    // 漏斗图
export const SHOW_TYPE__SUNBURST = 'SUNBURST_GRAPHICS'                // 旭日图
export const SHOW_TYPE__TREE_MAP = 'TREE_MAP_GRAPHICS'                // 矩形树图
export const SHOW_TYPE__SCATTER = 'SCATTER_GRAPHICS'                  // 散点图
export const SHOW_TYPE__MAP = 'MAP_GRAPHICS'                          // 地图

export const SHOW_TYPE__CAROUSEL = 'SHOW_CHART_CAROUSEL'              // 走马灯
export const SHOW_TYPE__TIME = 'SHOW_CHART_TIME'                      // 实时时间
export const SHOW_TYPE__IMAGE = 'SHOW_CHART_IMAGE'                    // 图片
export const SHOW_TYPE__PLACEHOLDER = 'SHOW_CHART_PLACEHOLDER'        // 占位组件
/**
 *
 * @type {string}
 */
export const VISIBLE_TYPE__FOLLOW = 'FOLLOW'        // 同仪表盘
export const VISIBLE_TYPE__CUSTOMIZE = 'CUSTOMIZE'  // 指定人员


/**
 * 数据来源类型
 * @type {string}
 */
export const SOURCE_TYPE__FIXED = 'FIXED'           // 固定值
export const SOURCE_TYPE__FLOW_FORM = 'FLOW_FORM'   // 流程表单
export const SOURCE_TYPE__DASHBOARD_CHART = 'DASHBOARD_CHART'     // 仪表盘
export const SOURCE_TYPE__AGGREGATION_TABLE = 'AGGREGATION_TABLE' // 聚合表
export const SOURCE_TYPE__JOIN_TABLE = 'JOIN_TABLE'               // 多表关联
export const SOURCE_TYPE__APPEND_TABLE = 'APPEND_TABLE'           // 追加合并表
export const SOURCE_TYPE__GROUP_TABLE = 'GROUP_TABLE'             // 分组合并表

/**
 * （纬度）日期类和位置类控件汇总方式（groupBy）
 * @type {string}
 */
export const GROUP_BY_TYPE__Y = 'Y'       // 年
export const GROUP_BY_TYPE__Y_Q = 'Y_Q'        // 年-季
export const GROUP_BY_TYPE__Y_M = 'Y_M'     // 年-月
export const GROUP_BY_TYPE__Y_W = 'Y_W'     // 年-周
export const GROUP_BY_TYPE__Y_M_D = 'Y_M_D'   // 年-月-日
export const GROUP_BY_TYPE__P = 'P'       // 省
export const GROUP_BY_TYPE__P_C = 'P_C'     // 省-市
export const GROUP_BY_TYPE__P_C_A = 'P_C_A'     // 省-市

/**
 * （指标）展示字段汇总方式（注意：除计数外都只支持数字类型）
 * @type {string}
 */
export const STATISTICS_STRATEGY__COUNT = 'COUNT'  // 计数
export const STATISTICS_STRATEGY__SUM = 'SUM'  // 求和
export const STATISTICS_STRATEGY__AVG = 'AVG'  // 平均值
export const STATISTICS_STRATEGY__MAX = 'MAX'  // 最大值
export const STATISTICS_STRATEGY__MIN = 'MIN'  // 最小值
export const STATISTICS_STRATEGY__DISTINCT_COUNT = 'DISTINCT COUNT' // 去重计数


export const ADVANCED_COMPUTE_R = 'R' // 占比
export const ADVANCED_COMPUTE_MOMV = 'MoMv' // 环比增长值
export const ADVANCED_COMPUTE_MOMR = 'MoMr' // 环比增长率
export const ADVANCED_COMPUTE_YOYV_Y = 'YoYv_Y' // 上年同比增长值
export const ADVANCED_COMPUTE_YOYR_Y = 'YoYr_Y' // 上年同比增长率
export const ADVANCED_COMPUTE_YOYV_M = 'YoYv_M' // 上月同比增长值
export const ADVANCED_COMPUTE_YOYR_M = 'YoYr_M' // 上月同比增长率
export const ADVANCED_COMPUTE_YOYV_W = 'YoYv_W' // 上周同比增长值
export const ADVANCED_COMPUTE_YOYR_W = 'YoYr_W' // 上周同比增长率


/**
 * 快捷方式图表 -按钮布局类型
 * @type {string}
 */
export const SHORTCUT_LAYOUT_MODE__ADAPT = 'adapt' // 自适应
export const SHORTCUT_LAYOUT_MODE__FIXED = 'fixed' // 自适应

/**
 * 快捷方式图表 -按钮操作类型
 * @type {string}
 */
export const SHORTCUT_BUTTON_TYPE__APPLY_FORM = 'applyForm' // 发起表单
export const SHORTCUT_BUTTON_TYPE__OPEN_VIEW = 'openView'   // 打开视图
export const SHORTCUT_BUTTON_TYPE__OPEN_URL = 'openUrl'     // 打开链接
export const SHORTCUT_BUTTON_TYPE__OPEN_APP_SET = 'openAppSet'     // 打开App设置
export const SHORTCUT_BUTTON_TYPE__OPEN_ORGAN = 'openOrganization'     // 打开组织架构
export const SHORTCUT_BUTTON_TYPE__OPEN_INVITE = 'openInvite'     // 打开邀请成员
export const SHORTCUT_BUTTON_TYPE__BIND_WECHAT = 'openBindWeChat'     // 打开邀请成员
export const SHORTCUT_BUTTON_TYPE__DATA_DRILLDOWN = 'dataDrilldown'     // 数据下钻
